import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Heart, Brain, Sparkles } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const benefits = [{
  icon: Zap,
  title: 'Cellular Energy',
  description: 'Optimize mitochondrial function for sustained vitality throughout your day.'
}, {
  icon: Heart,
  title: 'Longevity',
  description: 'Support healthy aging at the cellular level with proven NAD+ supplementation.'
}, {
  icon: Brain,
  title: 'Mental Clarity',
  description: 'Enhance cognitive function and maintain focus during demanding moments.'
}, {
  icon: Sparkles,
  title: 'Cellular Repair',
  description: "Activate your body's natural repair mechanisms for optimal wellness."
}];
export function ScienceSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.2
  });
  return <section id="science" className="px-6 py-32 md:py-40 bg-white" ref={ref as React.RefObject<HTMLElement>} data-id="element-323">
      <div className="max-w-7xl mx-auto" data-id="element-324">
        <motion.div className="text-center mb-20" initial={{
        y: 40,
        opacity: 0
      }} animate={isVisible ? {
        y: 0,
        opacity: 1
      } : {
        y: 40,
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-325">
          <p className="text-sm tracking-[0.3em] uppercase mb-6 text-zinc-600" data-id="element-326">
            The Science
          </p>
          <h2 className="text-4xl md:text-6xl font-serif mb-6" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-327">
            Precision Wellness
          </h2>
          <p className="text-lg text-zinc-600 max-w-2xl mx-auto" data-id="element-328">
            NAD+ is essential for cellular metabolism, DNA repair, and energy
            production. Our formulation delivers bioavailable NAD+ precursors
            with uncompromising purity.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-329">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} className="group" initial={{
            y: 40,
            opacity: 0
          }} animate={isVisible ? {
            y: 0,
            opacity: 1
          } : {
            y: 40,
            opacity: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2 + index * 0.1,
            ease: 'easeOut'
          }} data-id="element-330">
                <div className="mb-6 inline-flex p-4 bg-zinc-950 text-white rounded-full group-hover:bg-zinc-800 transition-colors duration-300" data-id="element-331">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-332" />
                </div>
                <h3 className="text-2xl font-serif mb-4" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-333">
                  {benefit.title}
                </h3>
                <p className="text-zinc-600 leading-relaxed" data-id="element-334">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}